export default "__VITE_ASSET__DkxnvY9t__"